module.exports = __webpack_public_path__ + "static/deal_4-cd80b55b33ad5698e74b4bc59c2b3a4f.png";